module.exports = __webpack_public_path__ + "img/Europe.e673d091.svg";